module.exports = __webpack_public_path__ + "9740aab655a54875705eb564463068a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-31.png
// module id = 2195
// module chunks = 0